import { Validator } from "../validator"
import { Option } from "../../ntuc/userService/staticData"

enum SelectError {
    CHOICE = `errors.choice`,
}

// Can only handle string values instead of Option, hence the mapping
class SelectValidator implements Validator<Option, SelectError> {
    private options: Option[] = []
    private optionsKeys: string[] = []

    constructor(options: Option[]) {
        this.options = options
        this.optionsKeys = this.options.map((element: Option) => {
            return element.code
        })
    }

    validate(value: Option): SelectError | undefined {
        if (!this.optionsKeys.includes(value.code)) {
            return SelectError.CHOICE
        }
    }
}

export default SelectValidator
export { SelectError }